const CurrencyFormatter = new Intl.NumberFormat("en-In", {
  style: "currency",
  currency: "INR",
});

export default CurrencyFormatter;
